import React from "react";
import useDateTime from "../../hooks/useDateTime";

export default function TimeUntil({ date, includeFractionalSeconds }) {
  const { isValid, format, until } = useDateTime(
    date,
    includeFractionalSeconds
  );

  if (!isValid) return null;

  return <span title={format}>{until}</span>;
}
